import { useEffect, useState } from 'react';
import { CalendarDays, Clock } from 'lucide-react';
import { getPosts } from '../../services/postService.js';

export function PostList() {
  const [posts, setPosts] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let active = true;

    getPosts()
      .then((items) => {
        if (active) {
          setPosts(items);
          setStatus('ready');
        }
      })
      .catch(() => {
        if (active) {
          setStatus('error');
        }
      });

    return () => {
      active = false;
    };
  }, []);

  if (status === 'loading') {
    return <p className="muted">Cargando articulos...</p>;
  }

  if (status === 'error') {
    return <p className="muted">No se pudieron cargar los articulos.</p>;
  }

  return (
    <div className="post-grid">
      {posts.map((post) => (
        <article className="post-card" key={post.slug}>
          <div className="post-meta">
            <span>
              <CalendarDays size={16} />
              {new Intl.DateTimeFormat('es', { dateStyle: 'medium' }).format(new Date(post.date))}
            </span>
            <span>
              <Clock size={16} />
              {post.readingMinutes} min
            </span>
          </div>
          <h3>{post.title}</h3>
          <p>{post.excerpt}</p>
          <div className="tag-list">
            {post.tags.map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>
        </article>
      ))}
    </div>
  );
}
